/**
 * LEÓN BLANKS — Cart bridge
 * Integrates custom add-to-cart flows with Shopify Horizon cart drawer.
 */
(function () {
  'use strict';

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) {
        ids.push(el.dataset.sectionId);
      }
    });
    return ids;
  }

  function dispatchCartUpdate(cart, variantId, quantity, sections, productId) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: String(variantId),
          data: {
            source: 'product-form-component',
            itemCount: quantity,
            variantId: String(variantId),
            productId: productId ? String(productId) : '',
            sections: sections || {},
          },
        },
      })
    );
  }

  function animateToCart(source) {
    if (!source || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var destination = document.querySelector('[data-testid="cart-drawer-trigger"], .action__cart');
    if (!destination) return;

    var start = source.getBoundingClientRect();
    var end = destination.getBoundingClientRect();
    var flyer = source.cloneNode(true);
    flyer.className = 'lb-cart-flyer';
    flyer.setAttribute('aria-hidden', 'true');
    Object.assign(flyer.style, {
      position: 'fixed', left: start.left + 'px', top: start.top + 'px',
      width: start.width + 'px', height: start.height + 'px', zIndex: '99999',
      objectFit: 'cover', borderRadius: '12px', pointerEvents: 'none'
    });
    document.body.appendChild(flyer);
    var dx = end.left + end.width / 2 - (start.left + start.width / 2);
    var dy = end.top + end.height / 2 - (start.top + start.height / 2);
    flyer.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 0.95 },
      { transform: 'translate(' + (dx * 0.55) + 'px, ' + (dy * 0.25 - 50) + 'px) scale(.55)', opacity: 0.85, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.08)', opacity: 0.15 }
    ], { duration: 650, easing: 'cubic-bezier(.22,.8,.3,1)' }).finished.finally(function () {
      flyer.remove();
      destination.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 320 });
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {
        style: 'currency', currency: currency || 'MXN', maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  async function loadRecommendations(productId, currency) {
    if (!productId) return;
    try {
      var response = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=3&intent=related');
      if (!response.ok) return;
      var payload = await response.json();
      var products = (payload.products || []).filter(function (product) { return String(product.id) !== String(productId); }).slice(0, 3);
      var drawer = document.querySelector('cart-drawer-component .cart-drawer__content');
      if (!drawer || !products.length) return;

      drawer.querySelector('.lb-cart-recommendations')?.remove();
      var section = document.createElement('section');
      section.className = 'lb-cart-recommendations';
      var title = document.createElement('h3');
      title.textContent = 'También te puede interesar';
      section.appendChild(title);
      var list = document.createElement('div');
      list.className = 'lb-cart-recommendations__list';

      products.forEach(function (product) {
        var link = document.createElement('a');
        link.className = 'lb-cart-recommendation';
        link.href = product.url;
        if (product.featured_image) {
          var img = document.createElement('img');
          img.src = product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=180';
          img.alt = product.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        var copy = document.createElement('span');
        copy.className = 'lb-cart-recommendation__copy';
        var name = document.createElement('strong');
        name.textContent = product.title;
        var price = document.createElement('span');
        price.textContent = money(product.price, currency);
        copy.append(name, price);
        link.appendChild(copy);
        list.appendChild(link);
      });
      section.appendChild(list);
      var summary = drawer.querySelector('.cart-drawer__summary');
      drawer.insertBefore(section, summary || null);
    } catch (e) {
      console.warn('No se pudieron cargar las recomendaciones del carrito.', e);
    }
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.lbOriginalText = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Agregando…';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (btn.dataset.lbOriginalText) {
        btn.textContent = btn.dataset.lbOriginalText;
      }
    }
  }

  async function addToCart(variantId, quantity, options) {
    options = options || {};
    quantity = quantity || 1;
    variantId = parseInt(variantId, 10);

    if (!variantId) {
      throw new Error('Variant ID required');
    }

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));

    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }
    formData.append('sections_url', window.location.pathname);

    var cartAddUrl =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

    var response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    var data = await response.json();

    if (data.status) {
      throw new Error(data.description || data.message || 'Error al agregar al carrito');
    }

    var cart = null;
    try {
      var cartRes = await fetch('/cart.js');
      cart = await cartRes.json();
    } catch (e) {
      cart = { item_count: quantity };
    }

    animateToCart(options.image || options.source);
    dispatchCartUpdate(cart, variantId, quantity, data.sections, data.product_id);
    loadRecommendations(data.product_id, cart.currency);

    return { cart: cart, sections: data.sections, item: data };
  }

  window.LeonCart = {
    add: addToCart,
    dispatch: dispatchCartUpdate,
  };

  /* Intercept quick-add forms (homepage, cards) */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-leon-cart-add], .lb-product-card__quick-add-form')) return;

      event.preventDefault();

      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var btn = form.querySelector('[type="submit"]');

      if (!idInput || !idInput.value) return;

      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      setButtonLoading(btn, true);

      var sourceImage = form.closest('.product-card, .lb-product-card')?.querySelector('img');
      addToCart(idInput.value, quantity, { image: sourceImage })
        .catch(function (err) {
          alert(err.message || 'No se pudo agregar al carrito');
        })
        .finally(function () {
          setButtonLoading(btn, false);
        });
    },
    true
  );
})();
